// ==========================================
// BACKGROUND SPOTLIGHT EFFECT
// ==========================================

const bgSpotlight = document.querySelector('.bg-spotlight');

if (bgSpotlight) {
  document.addEventListener('mousemove', (e) => {
    const x = (e.clientX / window.innerWidth) * 100;
    const y = (e.clientY / window.innerHeight) * 100;

    bgSpotlight.style.setProperty('--mouse-x', `${x}%`);
    bgSpotlight.style.setProperty('--mouse-y', `${y}%`);
  });
}

// ==========================================
// MOBILE NAVIGATION
// ==========================================

const burger = document.querySelector('.nav__burger');
const navMenu = document.querySelector('.nav__menu');

burger?.addEventListener('click', () => {
  burger.classList.toggle('is-active');
  navMenu?.classList.toggle('is-active');
  document.body.style.overflow = navMenu?.classList.contains('is-active') ? 'hidden' : '';
});

// Close menu when clicking on a link
document.querySelectorAll('.nav__link').forEach(link => {
  link.addEventListener('click', () => {
    burger?.classList.remove('is-active');
    navMenu?.classList.remove('is-active');
    document.body.style.overflow = '';
  });
});

// ==========================================
// SMOOTH SCROLL
// ==========================================

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const href = this.getAttribute('href');

    if (href === '#' || href.startsWith('http')) return;

    e.preventDefault();

    const target = document.querySelector(href);
    if (target) {
      const offsetTop = target.offsetTop - 80;

      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  });
});

// ==========================================
// SCROLL ANIMATIONS
// ==========================================

const observerOptions = {
  threshold: 0.1,
  rootMargin: '0px 0px -100px 0px'
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
    }
  });
}, observerOptions);

// Observe all elements with scroll animations
document.querySelectorAll('[data-scroll]').forEach(el => {
  observer.observe(el);
});

// ==========================================
// COUNTER ANIMATION
// ==========================================

function animateCounter(element, target) {
  const duration = 2000;
  const start = 0;
  const startTime = performance.now();

  function updateCounter(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    const easeOutQuad = progress * (2 - progress);
    const current = Math.floor(easeOutQuad * (target - start) + start);

    element.textContent = target >= 100 ? `${current}%` : `${current}+`;

    if (progress < 1) {
      requestAnimationFrame(updateCounter);
    } else {
      element.textContent = target >= 100 ? `${target}%` : `${target}+`;
    }
  }

  requestAnimationFrame(updateCounter);
}

// Trigger counters when hero stats are visible
const heroStats = document.querySelector('.hero__stats');
let countersAnimated = false;

if (heroStats) {
  const statsObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !countersAnimated) {
        document.querySelectorAll('.hero__stat-number').forEach(stat => {
          const count = parseInt(stat.getAttribute('data-count'));
          animateCounter(stat, count);
        });
        countersAnimated = true;
      }
    });
  }, { threshold: 0.5 });

  statsObserver.observe(heroStats);
}

// ==========================================
// PORTFOLIO FILTERS
// ==========================================

const filterBtns = document.querySelectorAll('.filter-btn');
const portfolioItems = document.querySelectorAll('.portfolio__item');

filterBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    // Remove active class from all buttons
    filterBtns.forEach(b => b.classList.remove('active'));

    // Add active class to clicked button
    btn.classList.add('active');

    const filter = btn.getAttribute('data-filter');

    portfolioItems.forEach(item => {
      const category = item.getAttribute('data-category');

      if (filter === 'all' || category === filter) {
        item.style.display = 'block';
        setTimeout(() => {
          item.style.opacity = '1';
          item.style.transform = 'translateY(0) scale(1)';
        }, 10);
      } else {
        item.style.opacity = '0';
        item.style.transform = 'translateY(50px) scale(0.95)';
        setTimeout(() => {
          item.style.display = 'none';
        }, 600);
      }
    });
  });
});

// ==========================================
// NAVBAR SCROLL EFFECT
// ==========================================

let lastScroll = 0;
const nav = document.querySelector('.nav');

window.addEventListener('scroll', () => {
  const currentScroll = window.pageYOffset;

  if (currentScroll > 100) {
    nav.style.padding = '1rem 0';
    nav.style.background = 'rgba(0, 0, 0, 0.95)';
  } else {
    nav.style.padding = '1.5rem 0';
    nav.style.background = 'rgba(0, 0, 0, 0.8)';
  }

  lastScroll = currentScroll;
});

// ==========================================
// FORM HANDLING
// ==========================================

const contactForm = document.querySelector('.contact__form');

contactForm?.addEventListener('submit', async (e) => {
  e.preventDefault();

  const formData = new FormData(contactForm);
  const data = Object.fromEntries(formData);

  console.log('Form submitted:', data);

  // Create success message
  const button = contactForm.querySelector('button[type="submit"]');
  const btnText = button.querySelector('.btn__text');
  const btnIcon = button.querySelector('.btn__icon');

  if (btnText && btnIcon) {
    const originalText = btnText.textContent;
    const originalIcon = btnIcon.textContent;

    btnText.textContent = '✓ Mesaj Trimis!';
    btnIcon.textContent = '';
    button.style.background = 'linear-gradient(135deg, #4caf50 0%, #45a049 100%)';
    button.disabled = true;

    // Reset form after 2 seconds
    setTimeout(() => {
      contactForm.reset();
      btnText.textContent = originalText;
      btnIcon.textContent = originalIcon;
      button.style.background = '';
      button.disabled = false;
    }, 2000);
  }

  // In production, send data to backend:
  // try {
  //   const response = await fetch('/api/contact', {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify(data)
  //   });
  //
  //   if (response.ok) {
  //     // Success handling
  //   }
  // } catch (error) {
  //   console.error('Error:', error);
  // }
});

// ==========================================
// PARALLAX EFFECT FOR IMAGES
// ==========================================

let ticking = false;

function updateParallax() {
  const scrolled = window.pageYOffset;

  // Hero background parallax
  const heroImage = document.querySelector('.hero__bg-image');
  if (heroImage) {
    heroImage.style.transform = `translateY(${scrolled * 0.5}px)`;
  }

  // About images parallax
  const aboutImages = document.querySelectorAll('.about__image-main img');
  aboutImages.forEach(img => {
    const rect = img.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      const offset = (window.innerHeight - rect.top) * 0.1;
      img.style.transform = `translateY(${offset}px) scale(1.05)`;
    }
  });

  ticking = false;
}

window.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(updateParallax);
    ticking = true;
  }
});

// ==========================================
// PORTFOLIO ITEM HOVER EFFECT
// ==========================================

portfolioItems.forEach(item => {
  item.addEventListener('mouseenter', function() {
    this.style.transition = 'transform 0.1s ease-out';
  });

  item.addEventListener('mousemove', function(e) {
    const rect = this.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = (y - centerY) / 20;
    const rotateY = (centerX - x) / 20;

    this.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-10px) scale(1.02)`;
  });

  item.addEventListener('mouseleave', function() {
    this.style.transition = 'transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1)';
    this.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) translateY(0) scale(1)';
  });
});

// ==========================================
// PROCESS STEP HOVER EFFECT
// ==========================================

document.querySelectorAll('.process__step').forEach((step, index) => {
  step.addEventListener('mouseenter', function() {
    this.style.transform = 'translateY(-10px) scale(1.02)';
  });

  step.addEventListener('mouseleave', function() {
    this.style.transform = 'translateY(0) scale(1)';
  });
});

// ==========================================
// FEATURE CARD ANIMATION
// ==========================================

document.querySelectorAll('.feature-card').forEach((card, index) => {
  card.style.animationDelay = `${index * 0.1}s`;

  card.addEventListener('mouseenter', function() {
    this.style.transform = 'translateY(-10px) scale(1.05)';
  });

  card.addEventListener('mouseleave', function() {
    this.style.transform = 'translateY(0) scale(1)';
  });
});

// ==========================================
// INITIALIZE
// ==========================================

console.log('🎨 Tattoo World Constanța - Website loaded successfully!');

// Log viewport info
console.log(`Viewport: ${window.innerWidth}x${window.innerHeight}`);

// Trigger initial parallax
updateParallax();
